var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManualIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H31.9852C40.8218 0 47.9852 7.16344 47.9852 16V31.9852C47.9852 40.8218 40.8218 47.9852 31.9852 47.9852H16C7.16344 47.9852 0 40.8218 0 31.9852V16Z",
    fill: "#FAF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9866 31.4903V16.4949C15.9866 15.8321 16.2499 15.1964 16.7186 14.7277C17.1873 14.259 17.823 13.9957 18.4858 13.9957H30.982C31.2471 13.9957 31.5014 14.101 31.6888 14.2885C31.8763 14.476 31.9816 14.7303 31.9816 14.9954V32.9898C31.9816 33.255 31.8763 33.5093 31.6888 33.6967C31.5014 33.8842 31.2471 33.9895 30.982 33.9895H18.4858C17.823 33.9895 17.1873 33.7262 16.7186 33.2575C16.2499 32.7888 15.9866 32.1531 15.9866 31.4903ZM15.9866 31.4903C15.9866 30.8275 16.2499 30.1918 16.7186 29.7231C17.1873 29.2544 17.823 28.9911 18.4858 28.9911H31.9816",
    stroke: "#9810FA",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManualIcon);
export default __webpack_public_path__ + "static/media/user_manual_icon.7fb16c509a5411c3782e54bbc984d14c.svg";
export { ForwardRef as ReactComponent };